import Vue from 'vue';
import Axios from 'axios'
import global from '../Global.vue'

// 按钮节流方法

const preventReClick = Vue.directive('preventReClick', {
	inserted: function(el, binding) {
		el.addEventListener('click', () => {
			if (!el.disabled) {
				el.disabled = true
				setTimeout(() => {
					el.disabled = false
				}, binding.value || 3000)
			}
			console.log(el.disabled)
		})
	}
});

// 将base64文件转成file
const toFile = {
	dataURLtoFile(dataurl, filename) {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], filename, {
			type: mime
		});
	}
}
// 将url 转换成 file 的公用方法
const toBase = {
	getBase() {
		var canvas = document.createElement("canvas");
		canvas.width = img.width;
		canvas.height = img.height;
		var ctx = canvas.getContext("2d");
		ctx.drawImage(img, 0, 0, img.width, img.height);
		var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
		var dataURL = canvas.toDataURL("image/" + ext);

		return dataURL;
	}

}

// 获取当前用户是安卓还是ios还是chrome还是ie还是360还是qq还是火狐
const userInfo = {
	isMobile() {
		return navigator.userAgent.match(
			/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
		);
		return true;
	},
	getMobileSystem() { //判断手机系统
		const u = navigator.userAgent.toLowerCase()
		if (u.indexOf('android') > -1 || u.indexOf('Linux') > -1) {
			return 'Android'
		} else if (u.indexOf('iphone') > -1 || u.indexOf('ipad') > -1) {
			return 'iOS'
		}
		return 'Android'
	}
}

export {
	toFile,
	userInfo
}
